<template>
  <div id="company-contact-form">
    <v-container>
    <v-flex xs12 sm8 md6>
    <p>{{ formTitle }}</p>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="title"
        :rules="titleRules"
        label="Title"
        required
      ></v-text-field>
      <v-text-field
        v-model="address"
        label="Address"
      ></v-text-field>
      <v-text-field
        v-model="telephone"
        label="Telephone"
      ></v-text-field>
      <v-text-field
        v-model="fax"
        label="Fax"
      ></v-text-field>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="Email"
        required
      ></v-text-field>
      <v-btn :disabled="!valid" @click="submit" color="primary">{{ buttonName }}</v-btn>
      <v-btn @click="clear" dark>Clear</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="goBack" dark>Back</v-btn>
    </v-form>
    </v-flex>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'login-form',
  props: ['buttonName', 'editData', 'formTitle'],
  data () {
    return {
      id: null,
      valid: true,
      title: '',
      titleRules: [
        v => !!v || 'Title is required'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      telephone: '',
      fax: '',
      // telephoneRules: [
      //   v => /[+0-9]+$/.test(v) || 'Telephone must be valid',
      //   v => (v && v.length <= 12) || 'Telephone must be less than 12 characters'
      // ],
      // faxRules: [
      //   v => /[+0-9]+$/.test(v) || 'Fax must be valid',
      //   v => (v && v.length <= 12) || 'Fax must be less than 12 characters'
      // ],
      address: ''
      // addressRules: [
      //   v => (v && v.length <= 50) || 'Address must be less than 50 characters'
      // ]
    }
  },
  beforeMount () {
    if (this.editData) {
      this.id = this.editData.id
      this.title = this.editData.title ? this.editData.title : this.editData.headline
      this.address = this.editData.address
      this.telephone = this.editData.telephone
      this.fax = this.editData.fax
      this.email = this.editData.email
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'adminUser/getLoggedInUser'
    })
  },
  methods: {
    submit () {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          const data = {
            id: this.id,
            title: this.title,
            address: this.address,
            telephone: this.telephone,
            fax: this.fax,
            email: this.email,
            current_user: this.currentUser
          }
          this.$emit('addItem', data)
        }
      } else {
        if (this.$refs.form.validate()) {
          const data = {
            id: this.id,
            title: this.title,
            address: this.address,
            telephone: this.telephone,
            fax: this.fax,
            email: this.email,
            current_user: this.currentUser
          }
          this.$emit('updateItem', this.editData.id, data)
        }
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    goBack () {
      this.$emit('goBack')
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CompanyContactInputForm.vue